export default function (url) {
	var location = url || '/welcome';
	window.location.href = location;
};
